import React from 'react';
import RedirectLinkComponent from '../../../../Elements/RedirectLinkComponent';

// A job in the automatic invoicing History by the id its platform gives it, as the invoice and the job lists show it,
// opening the job in a new tab as their link does. A job deleted since has no platform id left, so Bravo's id stands in.
export default function InvoiceAutomationJobId({ tpJobId = null, thirdPartyJobId = null }) {
  if (!thirdPartyJobId) {
    return tpJobId;
  }

  return (
    <RedirectLinkComponent
      isFigmaStyle={true}
      path='tpjobs'
      tooltipText={thirdPartyJobId}
      text={thirdPartyJobId}
      keyValuePairs={[
        { key: 'SelectedFieldworkOfficeIds', value: '' },
        { key: 'TpJobId', value: tpJobId },
      ]}
    />
  );
}
